export class RequestRetryBackOffHelper {
  constructor (
    retries = 1,
    retryDelaySeconds = 10,
    isExponential = false,
    maxDelaySeconds = 30
  ) {
    this.retries = retries
    this.isExponential = isExponential
    this.retryDelaySeconds = retryDelaySeconds
    this.maxDelaySeconds = maxDelaySeconds
  }
  async * getIterator () {
    let attempts = 0
    do {
      attempts++
      yield { attempts }
      await window.sleep(
        (this.isExponential
          ? Math.min(attempts * this.retryDelaySeconds, this.maxDelaySeconds)
          : this.retryDelaySeconds) * 1e3
      )
    } while (attempts < this.retries)
  }
}
